import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import ReactPlayer from 'react-player';
import classes from './VideoModal.module.css';
import { generateRandomString } from 'shared/utility';

export const videoModal = (props) => {
  const toggleVideo = () => {
    props.toggleVideo();
  };
  const handleModalClick = (e) => {
    if (e.target.id === 'modalFrame' && props.closeOnOutsideClick) toggleVideo();
  };

  const modalClasses = [classes.Modal, classes[props.className]];
  if (props.show === true) {
    modalClasses.push(classes.Shown);
  } else {
    modalClasses.push(classes.Hidden);
  }
  if (props.fullScreen) modalClasses.push(classes.FullScreen);
  if (props.shortWindow === true) modalClasses.push(classes.ShortWindow);
  if (props.orientation === 'horizontal') modalClasses.push(classes.Horizontal);
  const heightWidthVideoRatio = props.orientation === 'horizontal' ? 0.5625 : 1.778;
  const heightWidthContainerRatio = props.orientation === 'horizontal' ? 0.6078 : 1.645;

  // Standard horizontal video dimensions: 728 width & 409.5 height
  let videoHeight = props.orientation === 'horizontal' ? 409.5 : 728;
  let videoWidth = props.orientation === 'horizontal' ? 728 : 409.5;

  // If width is less than 728px or height is less than 442.5px, browser height to width ratio ratio is less than heightWidthContainerRatio,
  // then set video dimensions based off of browser height - 33px (video header). Else, set video dimensions as 1/heightWidthVideoRatio * width.
  if (
    (props.orientation === 'horizontal' && (window.innerWidth < 728 || window.innerHeight < 409.5 + 50)) ||
    (props.orientation === 'vertical' && (window.innerWidth < 409.5 || window.innerHeight < 728.5 + 50))
  ) {
    if (window.innerHeight / window.innerWidth < heightWidthContainerRatio) {
      videoHeight = window.innerHeight - 50;
      videoWidth = (1 / heightWidthVideoRatio) * videoHeight;
    } else {
      videoWidth = window.innerWidth;
      videoHeight = heightWidthVideoRatio * videoWidth;
    }
  }

  const videoContainerHeight = videoHeight + 50;

  return (
    <div id="modalFrame" name={props.name} onClick={handleModalClick} className={modalClasses.join(' ')}>
      <section
        id="modal-container"
        className={classes.modalMain}
        style={{
          maxHeight: props.isMobile ? 'calc(100vh - 80px)' : '100vh',
          height: `${videoContainerHeight}px`,
          width: `${videoWidth}px`,
          margin: props.isMobile ? '40px auto' : `calc(50vh - ${(videoHeight + 50) / 2}px) auto`,
        }}
      >
        {props.isMobile ? (
          <FontAwesomeIcon icon="times" className={[classes.CloseIcon, classes.Mobile].join(' ')} onClick={toggleVideo} />
        ) : (
          <div className={classes.CloseIconContainer}>
            <h2 className={classes.VideoTitle}>{props.title}</h2>
            <FontAwesomeIcon icon="times" className={classes.CloseIcon} onClick={toggleVideo} />
          </div>
        )}
        <div
          className={classes.PlayerWrapper}
          style={{
            height: props.isMobile ? `${Math.ceil(videoHeight) - 80}px` : `${Math.ceil(videoHeight)}px`,
            width: props.isMobile ? `${window.innerWidth}px` : `${Math.ceil(videoWidth)}px`,
          }}
        >
          <ReactPlayer
            className={classes.reactPlayer}
            url={`${props.videoUrl}?${generateRandomString(12)}`}
            height={props.isMobile ? '100%' : `${Math.ceil(videoHeight)}px`}
            width={props.isMobile ? '100%' : `${Math.ceil(videoWidth)}px`}
            controls
            playing={props.show}
          />
        </div>
      </section>
    </div>
  );
};

export default videoModal;
